// Application-wide constants
export const SUPPORT_EMAIL = "support@ompnt.com"

// UI timing constants (milliseconds)
export const TOOLTIP_ENTER_DELAY_MS = 300
